export default __webpack_public_path__ + "static/media/sample1.81a2c7f3.jpeg";